import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    link: "Locklist Video",
  },
  ja: {
    link: "ロックリストビデオ",
  },
  es: {
    link: "Vídeo de Lista de Candados",
  },
});

class Locklist_video extends Component {
  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const containerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };

    const linkStyle = {
      textAlign: "center",
      textDecoration: "underline",
      color: "black",
    };

    return (
      <div style={containerStyle}>
        <a
          href="https://youtu.be/YkWTZ5lsjko?si=0CokNu-FILEC4yi2"
          target="_blank"
          style={linkStyle}
        >
          {localizationStrings.link}
        </a>
      </div>
    );
  }
}

export default Locklist_video;
